export default (val, padding = '0') => {
  if (val < 10) {
    return `${padding}${val}`
  }

  return val
}